import React, { useEffect, useState } from 'react'
import { ModalBase } from '../ModalBase'
import {ReactComponent as CloseIcon} from '../../../media/felsv/dark_close_icon.svg'
import { useSelector } from 'react-redux'
import { State } from '../../../reducers'
import { DICCIONARIO } from '../../../constants/Diccionario'
import SearchSelect from '../../Inputs/SearchSelect'
import { getDateOperacionMes } from '../../../utils/stringDate'
import { handleChangeDocumentoFisico, onBlurDocumentoFisico } from '../../../actions/gestion-usuario/gu-generales/gu-generales'
import { DocFisico } from '../../../interfaces/general.interface'

export default function ModalDocFisicos({ idTipoDoc, documentoEdit, idTipoDefault, ocultarMonto, noCerrarAuto, minMes, onClicCerrar, onClicAgregar }: { idTipoDoc: Array<string>, documentoEdit?: DocFisico | null, idTipoDefault?: string, ocultarMonto?: boolean, noCerrarAuto?: boolean, minMes?: number, onClicCerrar: () => void, onClicAgregar: (documento: DocFisico) => void}) {
    const [form, setForm] = useState<DocFisico>(documentoEdit || {numId: "", tipo: idTipoDefault ? idTipoDefault : "", fecha:  new Date().toLocaleDateString('en-CA'), monto: "" })
    const [errorForm, setErrorForm] = useState({numId: "", tipo: "", fecha: "", monto: "" })
    const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const [tiposDocs, setTiposDocs] = useState<Array<any>>([])
  
    useEffect(() => {
      if(tipoDocumentosEmision.length > 0) setTiposDocs(tipoDocumentosEmision.filter((el) => idTipoDoc.includes(el.codigodocumento)))
    }, [tipoDocumentosEmision, idTipoDoc])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
        const {name, value} = e.target;
        if(handleChangeDocumentoFisico(name, value)) {
            setForm({...form, [name]:value})
            onBlur(e)
        }
    }

    const onBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
        const {name, value} = e.target;
        const message = onBlurDocumentoFisico(name, value);
        setErrorForm({...errorForm, [name]: message})
    }

    const submit = async(e: any) => {
        e.preventDefault();
        let errors = {...errorForm}
        errors.tipo = onBlurDocumentoFisico('tipo', form.tipo)
        errors.numId = onBlurDocumentoFisico('numId', form.numId)
        errors.fecha = onBlurDocumentoFisico('fecha', form.fecha)
        if(ocultarMonto !== true) errors.monto = onBlurDocumentoFisico('monto', form.monto)
        setErrorForm(errors)
        const err = Object.values(errors).some(error => error);
        if(!err) {
            onClicAgregar(form)
            if(noCerrarAuto !== true) onClicCerrar();
        }
    }

    return (
      <ModalBase Styles={{minWidth: "40%"}}>
        <div className='modal-error-buttons-fixed-top' style={{padding:"2%", backgroundColor:"white", zIndex:1000}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', }} >
            <h3 className='card-title l'>Datos del Documento Físico</h3>
            <button style={{backgroundColor: '#FFFFFF'}}  onClick={onClicCerrar} ><CloseIcon width={35} height={35} /></button>
          </div>
        </div>
        <div className='modal-content' style={{width:"100%", padding:"1% 2.5%",}}>
            <div className='w-form'>
                <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' onSubmit={submit}>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                            <label htmlFor='numId' className='field-label m'>Número de documento<span style={{color: 'red'}}>*</span></label>
                            <input autoFocus autoComplete='off' type='text' className='m text-field w-input' maxLength={40} data-name='numId' placeholder="Número de documento" id='numId' name='numId' value={form.numId} onChange={handleChange} onBlur={onBlur}/>
                            {errorForm.numId && <p className='alert s'>{errorForm.numId}</p>}
                        </div>
                        <div className='label-input'>
                            <label htmlFor='tipo' className='field-label m'>{DICCIONARIO.TIPO_DTE}<span style={{color: 'red'}}>*</span></label>
                            <SearchSelect defaultValue={null} placeholder={DICCIONARIO.TIPO_DTE} data={tiposDocs}  value={form.tipo}  name='tipo'  keyNameText='nombre'  keyNameValue='codigodocumento'  disabled={false}  placement="bottom" onChange={(value: any) => { handleChange({target: {value: value?.value, name: 'tipo'}})}} onBlur={onBlur}/>
                            {errorForm.tipo && <p className='alert s'>{errorForm.tipo}</p>}
                        </div>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                            <label htmlFor='fecha' className='field-label m'>Fecha de generación<span style={{color: 'red'}}>*</span></label>
                            <input autoComplete='off' type='date' className='m text-field w-input' maxLength={10} data-name='fecha' placeholder="Fecha Inicial" id='fecha' name='fecha'  min={getDateOperacionMes(minMes || -3)} max={getDateOperacionMes(0)} value={form.fecha}  onChange={handleChange} onBlur={onBlur}/>
                            {errorForm.fecha && <p className='alert s'>{errorForm.fecha}</p>}
                        </div>
                        {ocultarMonto !== true ? <div className='label-input'>
                            <label htmlFor='monto' className='field-label m'>Monto<span style={{color: 'red'}}>*</span></label>
                            <input autoComplete='off' type='text' className='m text-field w-input' maxLength={50} data-name='monto' placeholder="Monto" id='monto' name='monto' value={form.monto} onChange={handleChange} onBlur={onBlur}/>
                            {errorForm.monto && <p className='alert s'>{errorForm.monto}</p>}
                        </div> : <div className='label-input'></div>}
                    </div>
                    <div className='w-layout-hflex button-actions'>
                        <button type='button' className='m button transparent w-inline-block' onClick={onClicCerrar}>Cerrar</button>
                        <button type='submit' className='m button w-inline-block'>{documentoEdit ? "Actualizar" : "Agregar"}</button>
                    </div>
                </form>
            </div>
        </div>
      </ModalBase>
    )
}